const selectCountry = (country: string  | null | undefined) => {
    switch (country) {
        case 'US':
            return '1';
            break;
        case 'CA':
            return '1';
            break;
        case 'IN':
            return '91';
            break;
        case 'GB':
            return '44';
            break;
        case 'ZA':
            return '27';
            break;
        case 'AU':
            return '61';
            break;
        case 'SG':
            return '65';
            break;
        case 'MY':
            return '60';
            break;
        case 'AE':
            return '971';
            break;
        case 'SA':
            return '966';
            break;

        default:
            return '91';
            break;
    }
};

export default selectCountry; 